import { render, staticRenderFns } from "./MidiSender.vue?vue&type=template&id=7f67e7b0&scoped=true&"
import script from "./MidiSender.vue?vue&type=script&lang=js&"
export * from "./MidiSender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f67e7b0",
  null
  
)

export default component.exports